
export default class LocationChange {

    constructor() {

        // console.log( 'locationChange()' );

        // https://dirask.com/posts/JavaScript-on-location-changed-event-on-url-changed-event-DKeyZj

        var pushState = history.pushState;
        var replaceState = history.replaceState;

        history.pushState = function() {
            pushState.apply(history, arguments);
            window.dispatchEvent(new Event('pushstate'));
            window.dispatchEvent(new Event('locationchange'));
        };

        history.replaceState = function() {
            replaceState.apply(history, arguments);
            window.dispatchEvent(new Event('replacestate'));
            window.dispatchEvent(new Event('locationchange'));
        };

        window.addEventListener('popstate', function() {
            window.dispatchEvent(new Event('locationchange'))
        });
    }



}

/*

// Usage example:

window.addEventListener('locationchange', function(){
    console.log('onlocationchange event occurred!');
})

*/